// Section 24.15: tracing. A no-op unless a sink is installed by the app (?debug=1 or
// VITE_DEBUG) or a test. The sim never reads a clock; timing is the sink's job.

export interface TraceEvent {
  scope: string;
  data: Record<string, unknown>;
}

export type TraceSink = (event: TraceEvent) => void;

let sink: TraceSink | null = null;

/** Install or remove the trace sink. Observability only; never affects sim results. */
export function setTraceSink(next: TraceSink | null): void {
  sink = next;
}

export function trace(scope: string, data: Record<string, unknown> = {}): void {
  if (sink !== null) sink({ scope, data });
}
